// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bd6690c5","455":"2da13ffa","977":"9fb1ba9a"}[chunkId] + ".chunk.js";
};